/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Benefit_Claims_DescInputs */

const en_home_benefit_claims_desc = /** @type {(inputs: Home_Benefit_Claims_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canadian case managers to handle your claims directly — day or night.`)
};

const fr_home_benefit_claims_desc = /** @type {(inputs: Home_Benefit_Claims_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Des gestionnaires de dossiers canadiens pour traiter vos réclamations directement — jour et nuit.`)
};

/**
* | output |
* | --- |
* | "Canadian case managers to handle your claims directly — day or night." |
*
* @param {Home_Benefit_Claims_DescInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const home_benefit_claims_desc = /** @type {((inputs?: Home_Benefit_Claims_DescInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Benefit_Claims_DescInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_benefit_claims_desc(inputs)
	return fr_home_benefit_claims_desc(inputs)
});